import gql from 'graphql-tag';

export const WS_USER_UPDATE = gql`
  subscription($userIds: [String!]!) {
    userUpdate (userIds: $userIds) {
      userId
      profile {
        phoneNumber
        firstName
        lastName
        middleName
        dateOfBirth
        email
        avatar
        timezone
        policyId
        externalId
        isVerified
        isTosAccepted
        isIdEligible
        title
        gender
        changePasswordRequired
        SIPPhoneNumber
        address
        description
      }
      dynamicPermissions {
        orgNodeId
        roleResources {
          resourceCode
          create
          read
          update
          delete
          assign
          children {
            resourceCode
            create
            read
            update
            delete
            assign
          }
        }
      }
    }
  }
`;
